export default __webpack_public_path__ + "static/blob6-015c3391ddf69dfa085b905068f946dd.svg";